/* BARJE · Kalimera landing */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 821px)');

  function setTop() {
    var hero = document.querySelector('[data-kal-hero]');
    if (!hero) return;
    var top = hero.getBoundingClientRect().top + window.pageYOffset;
    document.documentElement.style.setProperty('--kal-top', Math.max(0, Math.round(top)) + 'px');
  }

  function initTimeline(root) {
    if (!root || root.dataset.kalReady) return;
    root.dataset.kalReady = '1';
    var track = root.querySelector('.kal-day__track');
    var list = root.querySelector('.kal-day__list');
    var fill = root.querySelector('.kal-day__fill');
    var clock = root.querySelector('.kal-day__clock');
    var moments = [].slice.call(root.querySelectorAll('.kal-moment'));
    var chips = [].slice.call(root.querySelectorAll('.kal-day__clock button'));
    var ticking = false;
    function progress() {
      if (!desktop.matches || !fill) return;
      var r = track.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (window.innerHeight * 0.55 - r.top) / r.height));
      fill.style.transform = 'scaleY(' + p + ')';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(function () { progress(); ticking = false; }); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', progress);
    progress();
    chips.forEach(function (chip, i) {
      chip.addEventListener('click', function () {
        var pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
        list.scrollTo({ left: moments[i].offsetLeft - pad, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    if ('IntersectionObserver' in window && chips.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = moments.indexOf(e.target);
          chips.forEach(function (c, j) { c.setAttribute('aria-current', j === i ? 'true' : 'false'); });
          if (chips[i] && clock) clock.scrollLeft = Math.max(0, chips[i].offsetLeft - 24);
        });
      }, { root: list, threshold: 0.6 });
      moments.forEach(function (m) { io.observe(m); });
    }
  }

  function initVideo(root) {
    if (!root || root.dataset.kalReady) return;
    var video = root.querySelector('video');
    var btn = root.querySelector('.kal-video__toggle');
    if (!video) return;
    root.dataset.kalReady = '1';
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    var userPaused = reduce;
    function label() { if (btn) btn.textContent = video.paused ? btn.dataset.play : btn.dataset.pause; }
    video.addEventListener('play', label);
    video.addEventListener('pause', label);
    if (btn) btn.addEventListener('click', function () {
      if (video.paused) { userPaused = false; video.play(); } else { userPaused = true; video.pause(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !userPaused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
          else if (!e.isIntersecting) video.pause();
        });
      }, { threshold: 0.35 }).observe(video);
    }
    label();
  }

  function initSticky() {
    var sticky = document.querySelector('.kal-sticky');
    var hero = document.querySelector('[data-kal-hero]');
    if (!sticky || !hero || sticky.dataset.kalReady || !('IntersectionObserver' in window)) return;
    sticky.dataset.kalReady = '1';
    var heroVisible = true, zones = new Set();
    function update() { sticky.classList.toggle('is-visible', !heroVisible && zones.size === 0); }
    new IntersectionObserver(function (e) { heroVisible = e[0].isIntersecting; update(); }, { threshold: 0.15 }).observe(hero);
    var zio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? zones.add(e.target) : zones.delete(e.target); });
      update();
    }, { threshold: 0.25 });
    document.querySelectorAll('[data-kal-cta-zone]').forEach(function (z) { zio.observe(z); });
  }

  function init() {
    setTop();
    document.querySelectorAll('[data-kal-timeline]').forEach(initTimeline);
    document.querySelectorAll('[data-kal-video]').forEach(initVideo);
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', setTop);
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; setTop(); } });
  document.addEventListener('shopify:section:load', init);
})();
